import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';

import { PublicAccessMiddleware, RouteAuthMiddleware } from './PermissionRoute';
import MainLayout from '../hoc/MainLayout';
import {
  ACCOUNTING_INVOICE_SETTINGS_PAGE_PATH,
  ACCOUNTING_INVOICES_PAGE_PATH,
  NEW_INVOICING_PAGE_PATH,
  INVOICE_LOGS_PAGE_PATH,
  ACCOUNTING_REPORT_PAGE_PATH,
  ACCOUNTS_PAGE_PATH,
  ADMINLOGS_PAGE_PATH,
  APIKEYS_PAGE_PATH,
  AUTOEDIT_VEHICLE_GALLERY_PAGE_PATH,
  BGERROR_GALLERY_PAGE_PATH_VEHID,
  BODYSTYLES_PAGE_PATH,
  COMPARISION_PAGE_PATH,
  CONFIRMVDS_GALLERY_PAGE_PATH_TYPEVIN,
  INVENTORY_DETAILS_PAGE_PATH_TYPE,
  CRONSTATS_PAGE_PATH,
  DASHBOARD_PAGE_PATH,
  DEALERLOG_PAGE_PATH,
  DEALERPROFILE_PAGE_PATH,
  DEALERPROFILE_PAGE_PATH_ID,
  DEFAULT_GUIDES_PAGE_PATH,
  EDITORPROFILE_PAGE_PATH,
  EDITTRACKER_PAGE_PATH,
  ERROR403_PAGE_PATH,
  EXPORT_ORDER_PAGE_PATH,
  EXPORT_PAGE_PATH,
  FEATURE_ICONS_PAGE_PATH,
  FILEMANAGER_PAGE_PATH,
  PROMO_BANNERS_PAGE_PATH,
  PROMO_BILLBOARDS_PAGE_PATH,
  FLAGS_PAGE_PATH,
  FORGOT_PASSWORD_PAGE_PATH,
  IMPORT_PAGE_PATH,
  INVENTORY_PAGE_PATH,
  INVOICING_PAGE_PATH,
  LOGIN_PAGE_PATH,
  MAINTANANCE_PAGE_PATH,
  MASTER_COMPOSITIONS_PAGE_PATH,
  MAVIS_GALLERY_PAGE_PATH_DEALER_VEH_VIN,
  MAVIS_PAGE_PATH,
  MAVIS_PRESENTS_PAGE_PATH,
  MAVIS_SETTINGS_PAGE_PATH,
  NOTIFICATIONS_PAGE_PATH_ID,
  OTPVERIFY_PAGE_PATH,
  OURMISSION_PAGE_PATH,
  PAGUIDES_PAGE_PATH,
  PHOTOGRAPHER_PROFILE_PAGE_PATH,
  PHOTON360_VIEWER_PAGE_FULL_PATH,
  QUALITY_CONTROL_EDITFLAGS_PAGE_PATH,
  QUALITY_CONTROL_PAGE_PATH,
  REPORTSETTINGS_PAGE_PATH,
  RESET_PASSWORD_PAGE_PATH_TOKEN,
  SALES_PAGE_PATH,
  // SALES_SLIDER_PAGE_PATH_VEHICLE,
  TEAMPROFILE_PAGE_PATH_ID,
  // TTM_PAGE_PATH,
  USERPROFILE_PAGE_PATH_ID,
  VEHICLE_GALLERY_PAGE_PATH_VIN,
  VIDEO_PAGE_PATH,
  INSTA360_PAGE_PATH,
  EXT360_PAGE_PATH,
  VIDEOGENERATION_PAGE_PATH,
  YOUTUBE_THUMBNAIL_PAGE_PATH,
  EDITOR_REPORT_PAGE_PATH,
  THEME_DOCS_PAGE_PATH,
  INTEGRATION_PAGE_PATH,
  RETRO_OPERATIONS_PATH,
  FEATURE_BANNERS_PAGE_PATH,
  FEATURE_BANNERS_SETTINGS_PAGE_PATH,
  FAQ_PATH,
  EXPORT_DMS_PATH,
  IMPORT_DMS_PATH,
  REPORT_STATISTICS_PATH,
  USER_ROLES_PATH,
  PHOTOGRAPHERS_ACCOUNTS_PAGE_PATH,
  ANNOUNCEMENT_BANNER_PAGE_PATH,
  // ANALYTICS_SETTINGS_PAGE_PATH,
  PROMO_BANNER_FAQ_PATH,
  AUTOPORT_SETTINGS_PAGE_PATH,
  LSP_RATE_PATH,
  DEVELOPER_ACCESS_PAGE_PATH,
  VIN_STATUS_TRACKER,
  VIN_STATUS_TRACKER_PATH_ID,
  // IMAGE_EDITOR_DEMO,
  LSP_INVOICES_PATH,
  RATIO_SETTINGS_PAGE_PATH,
  WINDOW_STICKER_DASHBOARD_PATH,
  WINDOW_STICKER_PRICING_PATH,
  VIN_TURNAROUND_PAGE_PATH,
  IMPORT_PAGE_PATH_ID,
  VEH_UPLOAD_HISTORY_PAGE_PATH
} from '../constants/appPathConst';
import PageSpinner from '../components/GeneralForm/PageSpinner';
import ErrorBoundary from '../components/GeneralForm/ErrorBoundary';
import Screen from '../components/PostHog/Screen';
import ThemeDocs from '../pages/ThemeDocs';
import {
  handleAuthLogout,
  handleSetAuthToken,
  handleFetchAuthToken,
  handleUnSetAuthToken,
  handleSetAuthTokenSession
} from '../containers/Auth/loginSlice';
import {
  handleLayoutIsDisplaySidebar,
  handleLayoutSetUserInfo,
  handleLayoutSetUserInfoSession,
  handleLayoutLoader,
  handleLayoutSetDealerInfo,
  handleChangePasswordToggle,
  handleOpDecalsToggle,
  handleLayoutScreenSizeObj,
  handleIsFullLayout,
  handleThemeArr,
  handleFullLayoutLoader,
  fetchMyAllDealersReq,
  handlePageTitleNBreadCrumb,
  handleWindowStickerBuyersguideOrderToggle,
  handleLayoutSetSessionDealerInfo,
  handleUnSetUserNDealer,
  toggleView,
  handleUpdateDemoMode,
  handleNeedTrainingToggle,
  set5PmReportModalOpen,
  setPhotoReportModalOpen
} from '../containers/MainLayout/mainLayoutSlice';
import { handleDealershipChange } from '../containers/Dashboard/dashboardSlice';
import RetroOperations from '../pages/RetroOperations';
// import Accounting from '../pages/Accounting';
// import BillingGroups from '../pages/BillingGroups';

// public pages
const Login = lazy(() => import('../containers/Auth/LoginContainer'));
const OtpVerify = lazy(() => import('../pages/OtpVerify'));
const ForgotPassword = lazy(() => import('../pages/ForgotPassword'));
const ResetPassword = lazy(() => import('../pages/ResetPassword'));
const Maintainance = lazy(() => import('../pages/Maintainance'));
const Error403 = lazy(() => import('../pages/Error403'));
const Error404 = lazy(() => import('../pages/Error404'));
const Photon360Viewer = lazy(() => import('../pages/Photon360Viewer'));
const DeveloperAccessPage = lazy(() => import('../pages/DeveloperAccessPage'));

const Demo360 = lazy(() => import('../pages/Demo360'));

// protected pages
const DashboardContainer = lazy(() => import('../containers/Dashboard/DashboardContainer'));
const EditTrackerContainer = lazy(() => import('../containers/EditTraker/editTrakerContainer'));
const Invoice = lazy(() => import('../pages/Invoice'));
const InventoryContainer = lazy(() => import('../containers/Inventory/InventoryContainer'));
const DealerComparisonContainer = lazy(() => import('../containers/DealerComparison/ComparisonContainer'));
const ExportPage = lazy(() => import('../pages/Export'));
const ImportPage = lazy(() => import('../pages/Import'));
const PhotographerAccountContainer = lazy(
  () => import('../containers/PhotographerAccount/PhotographerAccountsContainer')
);
const VinStatusTracker = lazy(() => import('../pages/VINStatusTracker'));
const LspInvoicing = lazy(() => import('../pages/LspInvoicing'));
const LspInvoices = lazy(() => import('../pages/LspInvoices'));
const SalesPage = lazy(() => import('../pages/Sales'));
const VideoPage = lazy(() => import('../pages/VideoPage'));
const Insta360Page = lazy(() => import('../pages/Insta360Page'));
const Ext360Page = lazy(() => import('../pages/Ext360Page'));
const AccountsContainer = lazy(() => import('../containers/Accounts/AccountsContainer'));
const QualityControl = lazy(() => import('../pages/QualityControl'));
const EditsFlags = lazy(() => import('../pages/EditsFlags'));
const Photographers = lazy(() => import('../pages/Photographers'));
const PhotographerProfile = lazy(() => import('../pages/PhotographerProfile'));
const DealerProfileContainer = lazy(() => import('../containers/DealerProfile/DealerProfileContainer'));
const Mavis = lazy(() => import('../pages/Mavis'));
// const TtmTracker = lazy(() => import('../pages/TtmTracker'));
const MasterShots = lazy(() => import('../pages/MasterShots'));
const DefaultComposition = lazy(() => import('../pages/DefaultComposition'));
const FileManager = lazy(() => import('../pages/FileManager'));
const PromotionalBannersContainer = lazy(
  () => import('../containers/PromotionalBanners/PromotionalBannersContainer')
);
const PromoBillboardsContainer = lazy(() => import('../containers/PromoBillboards/PromoBillboardsContainer'));
const MavisSettings = lazy(() => import('../pages/MavisSettings'));
const RatioSettings = lazy(() => import('../pages/RatioSettings'));
const Presets = lazy(() => import('../pages/Presets'));
const DealerShots = lazy(() => import('../pages/DealerShotsNew'));
// const DealerShots = lazy(() => import('../pages/DealerShots'));
const ReorderShots = lazy(() => import('../pages/ReorderShots'));
const TeamProfile = lazy(() => import('../pages/TeamProfile'));
// const EditTracker = lazy(() => import('../pages/EditTracker'));
const Feature = lazy(() => import('../pages/Feature'));
const Flags = lazy(() => import('../pages/Flags'));
const BodyStyles = lazy(() => import('../pages/BodyTypes'));
const VehicleGallery = lazy(() => import('../pages/VehicleGallery'));
const MavisGallery = lazy(() => import('../components/Mavis/MavisGallery'));
const BgErrorGallery = lazy(() => import('../components/Invoice/BgErrorGallery'));
const Logs = lazy(() => import('../pages/Logs'));
const AdminLogs = lazy(() => import('../pages/AdminLogs'));
const Accounts = lazy(() => import('../pages/Account'));
const AutoportInvoice = lazy(() => import('../pages/AutoportInvoices'));
const ConfirmVdsGallery = lazy(() => import('../pages/ConfirmVdsGallery'));
const InventoryDetails = lazy(() => import('../components/inventory/InventoryDetails'));
const InvoiceSettings = lazy(() => import('../pages/invoiceSettings'));
const CronStats = lazy(() => import('../pages/CronStats'));
const EditorProfile = lazy(() => import('../pages/EditorProfile'));
const Integration = lazy(() => import('../pages/Integration'));
const OurMission = lazy(() => import('../pages/OurMission'));
const AccountReport = lazy(() => import('../pages/AccountReport'));
const InvoiceLogs = lazy(() => import('../pages/InvoiceLogs'));
const APIkeys_DealerAssets = lazy(() => import('../pages/APIKeyPage'));
const VideoGenerationContainer = lazy(() => import('../containers/VideoGeneration/VideoGenerationContainer'));
const YoutubeThumbnailContainer = lazy(
  () => import('../containers/YoutubeThumbnail/YoutubeThumbnailContainer')
);
const DealerBanner = lazy(() => import('../pages/FeatureBanners/DealerBanner'));
const Notifications = lazy(() => import('../pages/Notifications'));
const ReportSettings = lazy(() => import('../pages/ReportSettings'));
const BannerSettingsContainer = lazy(() => import('../containers/FeatureBanners/BannerSettingsContainer'));
const EditorReport = lazy(() => import('../pages/EditorReport'));
const FaqPage = lazy(() => import('../pages/Faq'));
const ReportStatisticsPage = lazy(() => import('../pages/ReportStatistics'));
const ExportDMSContainer = lazy(() => import('../containers/ExportDMS/ExportDMSContainer'));
const UserRoleContainer = lazy(() => import('../containers/UserRoles/UserRoleContainer'));
const ImportDMSContainer = lazy(() => import('../containers/ImportDMS/ImportDMSContainer'));
const AnnouncementsBannerPage = lazy(() => import('../pages/AnnouncementsBanner/AnnouncementsBanner'));
// const AnalyticsSettingsPage = lazy(() => import('../pages/AnalyticsSettings'));
// const ImageEditorDemo = lazy(() => import('../pages/ImageEditorDemo'));
const PromoBannerFaqsPage = lazy(() => import('../pages/PromoBannerFaqsPage'));
const WindowStickerOrderPage = lazy(() => import('../pages/WindowSticker/Orders'));
const WindowStickerSettingPage = lazy(() => import('../pages/WindowSticker/Settings'));
const AutoportSettingsPage = lazy(() => import('../pages/AutoportSettings'));
const VinTurnaroundPage = lazy(() => import('../pages/VinTurnaround/VinTurnaround'));
const VehicleUploadHistoryPage = lazy(() => import('../pages/VehicleUploadHistory'));

const ContentRoutes = props => {
  const objProps = { ...props, location: useLocation(), navigate: useNavigate() };

  return (
    <Suspense fallback={<PageSpinner />}>
      <Routes>
        <Route
          element={
            <PublicAccessMiddleware
              restricted={[
                LOGIN_PAGE_PATH,
                OTPVERIFY_PAGE_PATH,
                FORGOT_PASSWORD_PAGE_PATH,
                RESET_PASSWORD_PAGE_PATH_TOKEN
              ].includes(location.pathname)}
            />
          }
        >
          <Route exact path={LOGIN_PAGE_PATH} element={<Screen name="login"><Login {...objProps} /></Screen>} />
          <Route exact path={OTPVERIFY_PAGE_PATH} element={<Screen name="otp_verify"><OtpVerify {...objProps} /></Screen>} />
          <Route exact path={FORGOT_PASSWORD_PAGE_PATH} element={<Screen name="forgot_password"><ForgotPassword {...objProps} /></Screen>} />
          <Route exact path={RESET_PASSWORD_PAGE_PATH_TOKEN} element={<Screen name="reset_password"><ResetPassword {...objProps} /></Screen>} />
          <Route exact path={MAINTANANCE_PAGE_PATH} element={<Screen name="maintenance"><Maintainance {...objProps} /></Screen>} />
          <Route exact path={ERROR403_PAGE_PATH} element={<Screen name="error_403"><Error403 {...objProps} /></Screen>} />
          <Route exact path={PHOTON360_VIEWER_PAGE_FULL_PATH} element={<Screen name="photon360_viewer"><Photon360Viewer {...objProps} /></Screen>} />
          <Route exact path="/demoviewer" element={<Screen name="demo360"><Demo360 {...objProps} /></Screen>} />
        </Route>

        <Route element={<RouteAuthMiddleware />}>
          <Route exact path={DASHBOARD_PAGE_PATH} element={<Screen name="dashboard"><DashboardContainer {...objProps} /></Screen>} />
          <Route
            exact
            path={PHOTOGRAPHERS_ACCOUNTS_PAGE_PATH}
            element={<Screen name="photographers_accounts"><PhotographerAccountContainer {...objProps} /></Screen>}
          />
          <Route exact path={INVOICING_PAGE_PATH} element={<Screen name="invoicing_legacy"><Invoice {...objProps} /></Screen>} />
          <Route exact path={INVENTORY_PAGE_PATH} element={<Screen name="inventory"><InventoryContainer {...objProps} /></Screen>} />
          <Route exact path={COMPARISION_PAGE_PATH} element={<Screen name="dealer_comparison"><DealerComparisonContainer {...objProps} /></Screen>} />
          <Route exact path={EXPORT_PAGE_PATH} element={<Screen name="export"><ExportPage {...objProps} /></Screen>} />
          <Route exact path={IMPORT_PAGE_PATH} element={<Screen name="import"><ImportPage {...objProps} /></Screen>} />
          <Route exact path={IMPORT_PAGE_PATH_ID} element={<Screen name="import"><ImportPage {...objProps} /></Screen>} />
          <Route exact path={SALES_PAGE_PATH} element={<Screen name="sales"><SalesPage {...objProps} /></Screen>} />
          <Route exact path={VIDEO_PAGE_PATH} element={<Screen name="video"><VideoPage {...objProps} /></Screen>} />
          <Route exact path={INSTA360_PAGE_PATH} element={<Screen name="insta360"><Insta360Page {...objProps} /></Screen>} />
          <Route exact path={EXT360_PAGE_PATH} element={<Screen name="ext360"><Ext360Page {...objProps} /></Screen>} />
          <Route exact path={ACCOUNTS_PAGE_PATH} element={<Screen name="accounts"><AccountsContainer {...objProps} /></Screen>} />
          <Route exact path={QUALITY_CONTROL_PAGE_PATH} element={<Screen name="qc"><QualityControl {...objProps} /></Screen>} />
          <Route exact path={QUALITY_CONTROL_EDITFLAGS_PAGE_PATH} element={<Screen name="qc_edits_flags"><EditsFlags {...objProps} /></Screen>} />
          <Route exact path={PHOTOGRAPHER_PROFILE_PAGE_PATH} element={<Screen name="photographer_profile"><Photographers {...objProps} /></Screen>} />
          <Route exact path={DEALERPROFILE_PAGE_PATH} element={<Screen name="dealer_profile"><DealerProfileContainer {...objProps} /></Screen>} />
          <Route exact path={DEALERPROFILE_PAGE_PATH_ID} element={<Screen name="dealer_profile"><DealerProfileContainer {...objProps} /></Screen>} />
          <Route exact path={MAVIS_PAGE_PATH} element={<Screen name="mavis"><Mavis {...objProps} /></Screen>} />
          <Route exact path={MAVIS_SETTINGS_PAGE_PATH} element={<Screen name="mavis_settings"><MavisSettings {...objProps} /></Screen>} />
          <Route exact path={RATIO_SETTINGS_PAGE_PATH} element={<Screen name="ratio_settings"><RatioSettings {...objProps} /></Screen>} />
          <Route exact path={MAVIS_PRESENTS_PAGE_PATH} element={<Screen name="presets"><Presets {...objProps} /></Screen>} />
          <Route exact path={PAGUIDES_PAGE_PATH} element={<Screen name="dealer_shots"><DealerShots {...objProps} /></Screen>} />
          <Route exact path={EXPORT_ORDER_PAGE_PATH} element={<Screen name="reorder_shots"><ReorderShots {...objProps} /></Screen>} />
          <Route exact path={FILEMANAGER_PAGE_PATH} element={<Screen name="file_manager"><FileManager {...objProps} /></Screen>} />
          <Route exact path={EXPORT_DMS_PATH} element={<Screen name="export_dms"><ExportDMSContainer {...objProps} /></Screen>} />
          <Route exact path={IMPORT_DMS_PATH} element={<Screen name="import_dms"><ImportDMSContainer {...objProps} /></Screen>} />
          <Route
            exact
            path={PROMO_BANNERS_PAGE_PATH}
            element={<Screen name="promo_banners"><PromotionalBannersContainer {...objProps} /></Screen>}
          />
          <Route
            exact
            path={PROMO_BILLBOARDS_PAGE_PATH}
            element={<Screen name="promo_billboards"><PromoBillboardsContainer {...objProps} /></Screen>}
          />
          <Route exact path={FAQ_PATH} element={<Screen name="faq"><FaqPage {...objProps} /></Screen>} />
          <Route exact path={USER_ROLES_PATH} element={<Screen name="user_roles"><UserRoleContainer {...objProps} /></Screen>} />
          <Route exact path={MASTER_COMPOSITIONS_PAGE_PATH} element={<Screen name="master_compositions"><MasterShots {...objProps} /></Screen>} />
          <Route exact path={DEFAULT_GUIDES_PAGE_PATH} element={<Screen name="default_composition"><DefaultComposition {...objProps} /></Screen>} />
          <Route exact path={USERPROFILE_PAGE_PATH_ID} element={<Screen name="user_profile"><PhotographerProfile {...objProps} /></Screen>} />
          <Route exact path={EDITORPROFILE_PAGE_PATH} element={<Screen name="editor_profile"><EditorProfile {...objProps} /></Screen>} />
          <Route exact path={INTEGRATION_PAGE_PATH} element={<Screen name="integration"><Integration {...objProps} /></Screen>} />
          <Route exact path={TEAMPROFILE_PAGE_PATH_ID} element={<Screen name="team_profile"><TeamProfile {...objProps} /></Screen>} />
          <Route exact path={EDITTRACKER_PAGE_PATH} element={<Screen name="edit_tracker"><EditTrackerContainer {...objProps} /></Screen>} />
          <Route exact path={VEHICLE_GALLERY_PAGE_PATH_VIN} element={<Screen name="vehicle_gallery"><VehicleGallery {...objProps} /></Screen>} />
          <Route exact path={BGERROR_GALLERY_PAGE_PATH_VEHID} element={<Screen name="bg_error_gallery"><BgErrorGallery {...objProps} /></Screen>} />
          <Route
            exact
            path={MAVIS_GALLERY_PAGE_PATH_DEALER_VEH_VIN}
            element={<Screen name="mavis_gallery"><MavisGallery {...objProps} /></Screen>}
          />
          <Route
            exact
            path={CONFIRMVDS_GALLERY_PAGE_PATH_TYPEVIN}
            element={<Screen name="confirm_vds_gallery"><ConfirmVdsGallery {...objProps} /></Screen>}
          />
          <Route exact path={INVENTORY_DETAILS_PAGE_PATH_TYPE} element={<Screen name="inventory_details"><InventoryDetails {...objProps} /></Screen>} />
          <Route exact path={FEATURE_ICONS_PAGE_PATH} element={<Screen name="feature_icons"><Feature {...objProps} /></Screen>} />
          <Route exact path={FLAGS_PAGE_PATH} element={<Screen name="feature_flags"><Flags {...objProps} /></Screen>} />
          <Route exact path={BODYSTYLES_PAGE_PATH} element={<Screen name="body_styles"><BodyStyles {...objProps} /></Screen>} />
          <Route exact path={DEALERLOG_PAGE_PATH} element={<Screen name="dealer_logs"><Logs {...objProps} /></Screen>} />
          <Route exact path={ADMINLOGS_PAGE_PATH} element={<Screen name="admin_logs"><AdminLogs {...objProps} /></Screen>} />
          <Route exact path={NEW_INVOICING_PAGE_PATH} element={<Screen name="autoport_invoices"><AutoportInvoice {...objProps} /></Screen>} />
          <Route exact path={ACCOUNTING_INVOICES_PAGE_PATH} element={<Screen name="accounting_invoices"><Accounts {...objProps} /></Screen>} />
          <Route exact path={ACCOUNTING_REPORT_PAGE_PATH} element={<Screen name="accounting_report"><AccountReport {...objProps} /></Screen>} />
          <Route exact path={INVOICE_LOGS_PAGE_PATH} element={<Screen name="invoice_logs"><InvoiceLogs {...objProps} /></Screen>} />
          <Route exact path={EDITOR_REPORT_PAGE_PATH} element={<Screen name="editor_report"><EditorReport {...objProps} /></Screen>} />
          <Route
            exact
            path={ACCOUNTING_INVOICE_SETTINGS_PAGE_PATH}
            element={<Screen name="invoice_settings"><InvoiceSettings {...objProps} /></Screen>}
          />
          <Route exact path={CRONSTATS_PAGE_PATH} element={<Screen name="cron_stats"><CronStats {...objProps} /></Screen>} />
          <Route exact path={OURMISSION_PAGE_PATH} element={<Screen name="our_mission"><OurMission {...objProps} /></Screen>} />
          <Route exact path={APIKEYS_PAGE_PATH} element={<Screen name="api_keys"><APIkeys_DealerAssets {...objProps} /></Screen>} />
          <Route
            exact
            path={VIDEOGENERATION_PAGE_PATH}
            element={<Screen name="video_generation"><VideoGenerationContainer {...objProps} /></Screen>}
          />
          <Route
            exact
            path={YOUTUBE_THUMBNAIL_PAGE_PATH}
            element={<Screen name="youtube_thumbnail"><YoutubeThumbnailContainer {...objProps} /></Screen>}
          />
          <Route exact path={FEATURE_BANNERS_PAGE_PATH} element={<Screen name="feature_banners"><DealerBanner {...objProps} /></Screen>} />
          <Route exact path={NOTIFICATIONS_PAGE_PATH_ID} element={<Screen name="notifications"><Notifications {...objProps} /></Screen>} />
          <Route exact path={REPORTSETTINGS_PAGE_PATH} element={<Screen name="report_settings"><ReportSettings {...objProps} /></Screen>} />
          <Route
            exact
            path={AUTOEDIT_VEHICLE_GALLERY_PAGE_PATH}
            element={<Screen name="autoedit_gallery"><VehicleGallery type="mavis" {...objProps} /></Screen>}
          />
          <Route exact path={THEME_DOCS_PAGE_PATH} element={<Screen name="theme_docs"><ThemeDocs {...objProps} /></Screen>} />
          <Route exact path={RETRO_OPERATIONS_PATH} element={<Screen name="retro_operations"><RetroOperations {...objProps} /></Screen>} />
          <Route
            exact
            path={FEATURE_BANNERS_SETTINGS_PAGE_PATH}
            element={<Screen name="feature_banner_settings"><BannerSettingsContainer {...objProps} /></Screen>}
          />
          <Route exact path={DEVELOPER_ACCESS_PAGE_PATH} element={<Screen name="developer_access"><DeveloperAccessPage {...objProps} /></Screen>} />
          <Route exact path={REPORT_STATISTICS_PATH} element={<Screen name="report_statistics"><ReportStatisticsPage {...objProps} /></Screen>} />
          <Route exact path={VIN_STATUS_TRACKER} element={<Screen name="vin_status_tracker"><VinStatusTracker {...objProps} /></Screen>} />
          <Route exact path={VIN_STATUS_TRACKER_PATH_ID} element={<Screen name="vin_status_tracker"><VinStatusTracker {...objProps} /></Screen>} />
          <Route exact path={LSP_RATE_PATH} element={<Screen name="lsp_rate"><LspInvoicing {...objProps} /></Screen>} />
          <Route exact path={LSP_INVOICES_PATH} element={<Screen name="lsp_invoices"><LspInvoices {...objProps} /></Screen>} />
          <Route
            exact
            path={ANNOUNCEMENT_BANNER_PAGE_PATH}
            element={<Screen name="announcement_banner"><AnnouncementsBannerPage {...objProps} /></Screen>}
          />

          <Route exact path={AUTOPORT_SETTINGS_PAGE_PATH} element={<Screen name="autoport_settings"><AutoportSettingsPage {...objProps} /></Screen>} />
          <Route exact path={PROMO_BANNER_FAQ_PATH} element={<Screen name="promo_banner_faqs"><PromoBannerFaqsPage {...objProps} /></Screen>} />

          {/* <Route exact path={IMAGE_EDITOR_DEMO} element={<ImageEditorDemo {...objProps} />} /> */}
          {/*    <Route exact path="/accounting" element={<Accounting {...objProps} />} />
          <Route exact path="/billinggroups" element={<BillingGroups {...objProps} />} />
            <Route exact path={TTM_PAGE_PATH} element={<TtmTracker {...objProps} />} />
           */}

          <Route
            exact
            path={WINDOW_STICKER_PRICING_PATH}
            element={<Screen name="window_sticker_pricing"><WindowStickerSettingPage {...objProps} /></Screen>}
          />
          <Route
            exact
            path={WINDOW_STICKER_DASHBOARD_PATH}
            element={<Screen name="window_sticker_dashboard"><WindowStickerOrderPage {...objProps} /></Screen>}
          />
          <Route exact path={VIN_TURNAROUND_PAGE_PATH} element={<Screen name="vin_turnaround"><VinTurnaroundPage {...objProps} /></Screen>} />
          <Route
            exact
            path={VEH_UPLOAD_HISTORY_PAGE_PATH}
            element={<Screen name="vehicle_upload_history"><VehicleUploadHistoryPage {...props} /></Screen>}
          />
        </Route>

        <Route path="*" element={<Screen name="error_404"><Error404 {...props} /></Screen>} />
      </Routes>
    </Suspense>
  );
};

const AppRoutes = props => {
  return (
    <Router>
      <MainLayout {...props}>
        <ErrorBoundary>
          <ContentRoutes {...props} />
        </ErrorBoundary>
      </MainLayout>
    </Router>
  );
};

// #region ToProps

const mapStateToProps = state => ({
  token: state.auth.token,
  isLoading: state.mainlayout.isLoading,
  isSidebarVisible: state.mainlayout.isSidebarVisible,
  user: state.mainlayout.user,
  dealer: state.mainlayout.dealer,
  changePasswordToggle: state.mainlayout.changePasswordToggle,
  opDecalsToggle: state.mainlayout.opDecalsToggle,
  isFullLayout: state.mainlayout.isFullLayout,
  allDealerList: state.mainlayout.allDealerList,
  pageTitle: state.mainlayout.pageTitle,
  pageBreadCrumb: state.mainlayout.pageBreadCrumb,
  activeDealersList: state.mainlayout.activeDealersList,
  inActiveDealersList: state.mainlayout.inActiveDealersList,
  windowStickerBuyersguideOrderToggle: state.mainlayout.windowStickerBuyersguideOrderToggle,
  themeArr: state.mainlayout.themeArr,
  screenSizeObj: state.mainlayout.screenSizeObj,
  alldealer: state.dashboard.alldealer,
  dashboardDealerChange: state.dashboard.dashboardDealerChange,
  dealershipChange: state.dashboard.dealershipChange,
  view: state.mainlayout.view,
  isDemoMode: state.mainlayout.isDemoMode,
  needTraining: state.mainlayout.needTraining,
  is5PmReportModalOpen: state.mainlayout.is5PmReportModalOpen,
  isPhotoReportModalOpen: state.mainlayout.isPhotoReportModalOpen
});
const mapDispatchToProps = {
  handleFullLayoutLoader,
  handleAuthLogout,
  handleSetAuthToken,
  handleSetAuthTokenSession,
  handleFetchAuthToken,
  handleUnSetAuthToken,
  handleLayoutIsDisplaySidebar,
  handlePageTitleNBreadCrumb,
  handleLayoutSetUserInfo,
  handleLayoutSetUserInfoSession,
  handleLayoutSetDealerInfo,
  handleLayoutLoader,
  handleDealershipChange,
  handleChangePasswordToggle,
  handleOpDecalsToggle,
  handleWindowStickerBuyersguideOrderToggle,
  handleLayoutScreenSizeObj,
  handleIsFullLayout,
  handleThemeArr,
  fetchMyAllDealersReq,
  handleLayoutSetSessionDealerInfo,
  handleUnSetUserNDealer,
  toggleView,
  handleUpdateDemoMode,
  handleNeedTrainingToggle,
  set5PmReportModalOpen,
  setPhotoReportModalOpen
};

// #endregion

export default connect(mapStateToProps, mapDispatchToProps)(AppRoutes);
